import { render, staticRenderFns } from "./LanguagesIndexComponent.vue?vue&type=template&id=04e5b906"
import script from "./LanguagesIndexComponent.vue?vue&type=script&lang=js"
export * from "./LanguagesIndexComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports